import * as t from "io-ts";
import nullable from "./nullable";
import { placeT } from "./place";
import { withFallback } from "io-ts-types";
const routeViewModelStopT = t.strict({
    countryCode: nullable(t.string),
    postcode: nullable(t.string),
    city: nullable(t.string),
});
const driverLoginEntryT = t.strict({
    loggedInAt: t.string,
    truckId: t.string,
    trailerId: nullable(t.string),
});
const stopStatusT = t.strict({
    arrivedDate: nullable(t.string),
    departedDate: nullable(t.string),
    completedDate: nullable(t.string),
    departedByDriverId: nullable(t.string),
    completedByDriverId: nullable(t.string),
});
export const routeViewModelT = t.strict({
    id: t.string,
    name: nullable(t.string),
    truckId: nullable(t.string),
    unpoweredTrailerId: nullable(t.string),
    note: nullable(t.string),
    ref: nullable(t.string),
    drivers: t.array(t.string),
    driverLogins: withFallback(t.record(t.string, driverLoginEntryT), {}),
    stopStatuses: withFallback(t.record(t.string, stopStatusT), {}),
    cargoOrder: t.array(t.string),
    startDate: nullable(t.string),
    endDate: nullable(t.string),
    archived: t.boolean,
    assignedTeamId: t.string,
    firstStop: nullable(routeViewModelStopT),
    lastStop: nullable(routeViewModelStopT),
    waypointNote: nullable(t.string),
    intendedStartDate: nullable(t.string),
    operationInProgress: withFallback(t.boolean, false),
});
export const routeViewModelsT = t.array(routeViewModelT);
export const routeT = t.strict({
    id: t.string,
    radius: nullable(t.number),
    note: nullable(t.string),
    ref: nullable(t.string),
    route_name: nullable(t.string),
    truckId: nullable(t.string),
    unpoweredTrailerId: nullable(t.string),
    cargo_order: t.array(t.string),
    archived: nullable(t.boolean),
    drivers: t.array(t.string),
    assignedTeamId: t.string,
    operationInProgress: withFallback(t.boolean, false),
});
export const routingResponseT = nullable(t.strict({
    linestring: nullable(t.array(t.tuple([t.number, t.number]))),
    waypoints: t.array(t.tuple([t.number, t.number])),
    distanceKm: nullable(t.number),
}));
export const waypointDataT = t.strict({
    place: placeT,
    note: nullable(t.string),
    shouldShowToDriver: withFallback(t.boolean, false),
});
export const routeInfoStopT = t.union([
    t.intersection([
        t.strict({
            id: t.string,
            type: t.literal("WAYPOINT"),
        }),
        waypointDataT,
    ]),
    t.strict({
        id: t.string,
        stopId: t.string,
        cargoId: t.string,
        type: t.literal("CARGO_STOP"),
    }),
]);
export const moveStopRequestT = t.strict({
    id: t.string,
    newIndex: t.number,
});
export const updateRouteVehicleT = t.strict({
    id: t.string,
    vehicleId: t.string,
});
export const routeInfoStopsT = t.array(routeInfoStopT);
export const moveStopInRouteStopOrderResponseT = t.strict({
    stopOrder: t.array(routeInfoStopT),
    stopOrderInvalidWarning: t.boolean,
});
//# sourceMappingURL=routes.js.map